import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanyBankFeedAccessContext } from '@/abilities/companyBankFeed/context';
import { COMPANY_BANK_FEED_DESTINATION, type CompanyBankFeedAbility } from '@/abilities/companyBankFeed/vocabulary';

// Rules only on the tabs; the page takes its access from them.
export const companyBankFeedRules = ({
  bankFeedTransactionViewGranted,
}: Pick<CompanyBankFeedAccessContext, 'bankFeedTransactionViewGranted'>): RawRuleOf<CompanyBankFeedAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanyBankFeedAbility>(createMongoAbility);
  if (bankFeedTransactionViewGranted) {
    can(['see', 'open'], COMPANY_BANK_FEED_DESTINATION, { destination: 'transactions' });
    can(['see', 'open'], COMPANY_BANK_FEED_DESTINATION, { destination: 'creditCards' });
  }
  return rules;
};
